import { ProgramaComparador } from "../types/general.type";
import { IUserGeolocation } from "../types/user-geolocation.interface";

export namespace AppStoreActions {

    // ===================================================
    // CONFIG
    // ===================================================

    export namespace Config {

        export class ChangeBreadCrumb {
            static readonly type = '[APP-STORE - CONFIG] setBreadCrumb';
            constructor(public payload: any) { }
        }

        export class AgregarUniversidadComparador {
            static readonly type = '[APP-STORE - CONFIG] AgregarUniversidadComparador';
            constructor(public payload: { id: number, nombre: string }[]) { }
        }

        export class QuitarUniversidadComparador {
            static readonly type = '[APP-STORE - CONFIG] QuitarUniversidadComparador';
            constructor(public payload: { id: number }) { }
        }

        export class AgregarProgramaComparador {
            static readonly type = '[APP-STORE - CONFIG] AgregarProgramaComparador';
            constructor(public payload: ProgramaComparador[]) { }
        }

        export class QuitarProgramaComparador {
            static readonly type = '[APP-STORE - CONFIG] QuitarProgramaComparador';
            constructor(public payload: { id: number, idUniversidad: number, idModalidadEstudio: number }) { }
        }

        export class SetUserGeolocation {
            static readonly type = '[APP-STORE - CONFIG] SetUsergeolocation';
            constructor(public payload: { userGeoLocation: IUserGeolocation }) { }
        }

    }

    // ===================================================
    // UI
    // ===================================================

    export namespace Ui {
        export class HideSidebar {
            static readonly type = '[APP-STORE - UI] hideSidebar';
            constructor(public payload: boolean) { }
        }

        export class SetMenu {
            static readonly type = '[APP-STORE - UI] SetMenu';
            constructor(public payload: { rawMenu: any[] }) { }
        }

        export class SetMobileLayout {
            static readonly type = '[APP-STORE - UI] SetMobileLayout';
            constructor(public payload: { isMobile: boolean }) { }
        }

        export class OpenComparadorInferior {
            static readonly type = '[APP-STORE - UI] ToogleComparadorInferior';
            constructor(public payload: { open: boolean }) { }
        }

        export class ColapsarComparadorInferior {
            static readonly type = '[APP-STORE - UI] ColapsarComparadorInferior';
            constructor(public payload: { collapse: boolean }) { }
        }

        export class SetStickyMenuElevation {
            static readonly type = '[APP-STORE - UI] SetStickyMenuElevation';
            constructor(public payload: { elevation: boolean }) { }
        }
    }

    // ===================================================
    // SESSION
    // ===================================================

    export namespace Session {

        export class Login {
            static readonly type = '[APP-STORE - SESSION] Login';
            constructor(public payload: { credentials: { userName: string, userPass: string } }) { }
        }

        export class SetToken {
            static readonly type = '[APP-STORE - SESSION] SetToken';
            constructor(public payload: { token: string }) { }
        }

        export class GetRawMenu {
            static readonly type = '[APP-STORE - SESSION] GetRawMenu';
            constructor(public payload: { idPerfil: number }) { }
        }

        export class SetSessionFromStorage {
            static readonly type = '[APP-STORE - SESSION] SetSessionFromStorage';
            constructor(public payload: { session: any }) { }
        }

        export class Logout {
            static readonly type = '[APP-STORE - SESSION] Logout';
            constructor() { }
        }

        export class SetRol {
            static readonly type = '[APP-STORE - SESSION] SetRol';
            constructor(public payload: { rol: number }) { }
        }

        export class GetRoles {
            static readonly type = '[APP-STORE - SESSION] GetRoles';
            constructor() { }
        }

        export class GetPermisos {
            static readonly type = '[APP-STORE - SESSION] GetPermisos';
            constructor() { }
        }
    }
}